import classnames from 'classnames';
import React, { ReactNode, forwardRef } from 'react';

const CSS = require('./Carousel.module.scss');

interface CarouselProp {
  as?: 'ul' | 'ol';
  className?: any;
  children: ReactNode;
  snapMode?: 'horizontal' | 'vertical' | 'none';
}

const Carousel = forwardRef(function Carousel(
  {
    as: Component = 'ul',
    className,
    children,
    snapMode = 'none',
  }: CarouselProp,
  ref: any,
) {
  const classes = classnames(CSS.Carousel, className, {
    [CSS.HorizontalSnappedCarousel]: snapMode === 'horizontal',
    [CSS.VerticalSnappedCarousel]: snapMode === 'vertical',
  });

  return (
    <Component className={classes} ref={ref}>
      {children}
    </Component>
  );
});

export default Carousel;
